import classNames from "classnames";
import { twMerge } from "tailwind-merge";

import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import FontAwesomeIcon from "components/FontAwesomeIcon";

import styles from "./style.module.scss";

type ButtonProps = {
  className?: string;
  icon?: IconDefinition;
  onClick: () => void;
  children?: React.ReactNode;
  disabled?: boolean;
  isProcessing?: boolean;
};

const Button = ({
  className,
  icon,
  onClick,
  children,
  disabled,
  isProcessing,
}: ButtonProps) => (
  <span
    className={classNames(
      styles.button,
      "py-[0.75em] px-[1.1em]",
      disabled || isProcessing ? "opacity-50" : "",
      isProcessing ? "cursor-wait" : "",
      className
    )}
    onClick={onClick}
  >
    {icon && (
      <FontAwesomeIcon
        icon={icon}
        className={twMerge(styles.icon, !children && "!mr-0")}
      />
    )}
    {children}
  </span>
);

export default Button;
